export const SCREEN_SM_MAX = "834px";
export const SCREEN_XL_MIN = "1440px";

export const createSizesMediaQueries = (sizes: { smSize: number; mdSize: number; xlSize?: number }): string => {
  const xlMediaQuery = sizes.xlSize ? `(min-width: ${SCREEN_XL_MIN}) ${sizes.xlSize}vw, ` : "";
  const mdMediaQuery = `(min-width: ${SCREEN_SM_MAX}) ${sizes.mdSize}vw, `;
  return `${xlMediaQuery}${mdMediaQuery}${sizes.smSize}vw`;
};
